import React from 'react';
import {Table} from 'semantic-ui-react';
import {TABLE_HEADERS, itemConstructor} from '../Utility/helpers'

export const TableConstructor = (target, data) => {
    console.log(data);
    data = data.slice(0, 10);

    console.log(data);
    return(
        <Table>
            <Table.Header>
                <Table.Row>
                    {TABLE_HEADERS[target].headers.map(header => <Table.HeaderCell key={header}> {header} </Table.HeaderCell>)}
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {
                    data.map(item => {
                        return(
                            <Table.Row key={item[TABLE_HEADERS[target].key]}>
                                {TABLE_HEADERS[target].fields.map((field, index) => {
                                    return (
                                        <Table.Cell key={index}>
                                            {
                                                itemConstructor(item, field)
                                            }
                                        </Table.Cell>
                                    )
                                })}
                            </Table.Row>
                        )
                    })
                }
            </Table.Body>
        </Table>
    )
}

